/**
 * Truncates a string to a specified length, appending an indicator if it exceeds the limit.
 *
 * @param text - The text to be truncated if it exceeds `maxCharacters`.
 * @param maxCharacters - The maximum allowed characters before truncation occurs.
 * @param ellipsis - The characters to append when truncating, indicating continuation (default: '…').
 * @returns The truncated text if `text` exceeds `maxCharacters`; otherwise, the original `text`.
 */
export const truncateText = (
  text: string,
  maxCharacters: number,
  ellipsis = '…',
): string => {
  if (text.length <= maxCharacters) return text;
  return text.slice(0, Math.max(maxCharacters - ellipsis.length, 0)) + ellipsis;
};
